import { useMutation } from '@tanstack/react-query';
import type { JobChangeProcessBoardPostRequest } from '../types/JobChangeProcessBoard';
import parseBoardResponse from './parseBoardResponse';

export default function usePostJobChangeProcessBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ title, divide_status, color_type }: JobChangeProcessBoardPostRequest) => {
      const response = await fetch(`/agent/api/job_change_process_boards`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          title,
          divide_status,
          color_type,
        }),
      });
      return parseBoardResponse(response, 'ボードの作成に失敗しました');
    },
  });
}
